import axios from "axios";
import { makeAutoObservable } from "mobx";
import CONSTANTS from "../utils/constants"

interface LoginData {
  [key: string]: string;
}

class Keys {
  getBaseUrl() {
    return "http://10.244.220.218:8494/AjmanSewerageConsolidatedUATAPI/api/";
  }

  getEncryptionSecretKey(){
    return 'AAECAwQFBgcICQoLDA0ODw==';
  }

  getEncryptionSecretIv(){
    return 'HR$2pIjHR$2pIj12';
  }
}

class Timer {
  posts = [];
  keys = new Keys();

  constructor() {
    makeAutoObservable(this);
  }

  get = async () => {
    try {
      console.log("process => ", process.env);
      let res = await axios.get(`${process.env.REACT_APP_API_URL}/posts`);
      console.log("response", res);
      this.posts = res.data;
    } catch (err) {
      console.log(err);
    }
  };

  getComplaintTypes = async (setData: any) => {
    await axios
      .get(
        "http://10.244.220.218:8494/AjmanSewerageEditProfileAPI/api/service/complaintypes"
      )
      .then((res) => {
        setData(res.data.result);
        console.clear();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFAQ = async (setData: React.Dispatch<React.SetStateAction<any>>) => {
    await axios
      .get(
        "http://10.244.220.218:8494/AjmanSewerageEditProfileAPI/api/service/faq"
      )
      .then((res) => {
        setData(res.data.result);
        console.clear();
      });
  };

  getNotification = async (
    setData: React.Dispatch<React.SetStateAction<any>>
  ) => {
    await axios
      .get(
        "http://10.244.220.218:8494/AjmanSewerageEditProfileAPI/api/service/notification"
      )
      .then((res) => {
        setData(res.data.result);
      });
  };

  getDashboard = async (setData: React.Dispatch<React.SetStateAction<any>>) => {
    await axios
      .get(
        `${this.keys.getBaseUrl()}api/service/faq`
      )
      .then((res) => {
        setData(res.data.result);
        console.clear();
      });
  };
}

export default Timer;
